import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await login(email, password);
    if (!result.success) {
      setError(result.error || 'Invalid email or password');
    } else {
      try {
        sessionStorage.setItem('bidflow_post_login', '1');
      } catch {
        // Ignore storage failures and continue login flow.
      }
      // Route to app entry so global billing gate controls the next step.
      navigate('/', { replace: true });
    }

    setIsLoading(false);
  };

  return (
    <div className="login-container login-container-centered">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo-wrap">
            <img
              src="/bidflow-removebg-preview.png"
              alt="BidFlow logo"
              className="login-logo"
            />
          </div>
          {/* <h1 className="login-wordmark">BidFlow</h1>
          <p className="login-subtitle">Sign in to continue</p> */}
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              id="email"
              type="email"
              className="form-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="password-input-wrapper">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                className="form-input form-input-password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                aria-pressed={showPassword}
              >
                {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
              </button>
            </div>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            <span className="login-button-text">
              {isLoading ? 'Signing in...' : 'Sign In'}
            </span>
            <span className="login-button-arrow">→</span>
          </button>
        </form>

        <div className="login-account-hint">
          <span>Need an account?</span>
          <a
            href="https://calendly.com/jessechoe10/demo-with-bidflow"
            target="_blank"
            rel="noopener noreferrer"
            className="login-account-meeting-btn"
          >
            Book a meeting
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
